export const STACKED_BREAKPOINT = 720;
export const LYRICS_WIDTH = 420;
export const MIN_LYRICS_HEIGHT = 420;
export const PRODUCE_WIDTH = 90;
export const PRODUCE_HEIGHT = 38;
export const MIN_LYRICS_PRODUCE_GAP = 10;
export const MIN_PRODUCE_CARD_GAP = 30;
export const MIN_AVATAR_LYRICS_GAP = 30;

export const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max);

export const readViewportSize = (): { width: number; height: number } => {
  if (typeof window === 'undefined') {
    return { width: 1440, height: 900 };
  }
  return { width: window.innerWidth, height: window.innerHeight };
};

export const isStackedViewport = (viewport: {
  width: number;
  height: number;
}): boolean =>
  viewport.width < STACKED_BREAKPOINT ||
  viewport.width / Math.max(viewport.height, 1) < 0.75;
